<template>
  <div
    style="display: flex; flex-direction: column; gap: 4px; border-top: 1px solid grey; border-bottom: 1px solid grey; padding: 10px;">
    <h4 style=" margin-bottom: 0px!important;">Import students</h4>
    <input id="fileInput" type="file" @change="upload" style="width: 50%;">
    <a target="_blank" href="/static/Sample_Class_File_Format.csv"><i class="large file excel icon"></i>Download
      a
      sample student
      list</a>
  </div>
</template>

<script>
import Papa from 'papaparse';
import readXlsxFile from 'read-excel-file';
import * as XLSX from "xlsx";

export default {
  name: 'StudentImport',
  components: { Papa },
  props: [],
  data() {
    return {
      students: null,
    };
  },
  methods: {
    upload(ev) {
      const fileToLoad = ev.target.files[0];

      const processRows = (rows) => {
        let dataRows = rows;
        let firstNameIndex = 0;
        let lastNameIndex = 1;

        // Check for header row
        if (rows.length && Array.isArray(rows[0])) {
          const headers = rows[0].map(h => (h || '').toString().toLowerCase());
          if (headers.some(h => h.toLowerCase() === 'first name')
            && (headers.some(h => h.toLowerCase() === 'surname') || headers.some(h => h.toLowerCase() === 'last name'))) {
            firstNameIndex = headers.findIndex(h => h.toLowerCase() === 'first name');
            lastNameIndex = headers.findIndex(h => h.toLowerCase() === 'surname');
            if (lastNameIndex === -1) {
              lastNameIndex = headers.findIndex(h => h.toLowerCase() === 'last name');
            }
            dataRows = rows.slice(1); // skip header
          }
          if (headers.some(col => col.toString().toLowerCase().includes('name'))) {
            dataRows = rows.slice(1); // skip header, still use first two columns
          }
        }
        this.students = dataRows
          .filter(row => row[firstNameIndex] || row[lastNameIndex])
          .map(row => ({
            firstName: row[firstNameIndex],
            lastName: row[lastNameIndex],
            dateOfBirth: null,
            gender: 1,
          }));
        this.$emit('imported');
      };

      if (fileToLoad.name.toLowerCase().endsWith('.csv')) {
        const reader = new FileReader();
        reader.onload = (fileLoadedEvent) => {
          // Parse CSV as array of arrays (no header)
          Papa.parse(fileLoadedEvent.target.result, {
            skipEmptyLines: true,
            complete: (results) => {
              processRows(results.data);
            },
          });
        };
        reader.readAsText(fileToLoad);
      } else if (fileToLoad.name.toLowerCase().endsWith('.xlsx') || fileToLoad.name.toLowerCase().endsWith('.xlsm')) {
        readXlsxFile(fileToLoad).then((rows) => {
          processRows(rows);
        });
      } else if (fileToLoad.name.toLowerCase().endsWith('.xls') || fileToLoad.name.toLowerCase().endsWith('.numbers')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          const rows = jsonData.map((row) => {
            return Object.values(row);
          });
          processRows(rows);
        };
        reader.readAsArrayBuffer(fileToLoad);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/students/StudentImport.vue